import { Box, Flex, HStack, Image } from "@chakra-ui/react";

import { Link } from "react-router-dom";

const BottomNavbar = () => {
  return (
    <Box bg="#5e17eb">
      <Flex gap={'85px'} className="BottomNavbar" alignItems={"center"} justifyContent='center' paddingBlock={'15px'} paddingTop='15px'>

       <HStack className="BottomNavbarBox">
        <div className="circular-imageh">
          <Image 
            src=".\icons\1.svg"
          />
          </div>
           <Link to="/products" className="custom-linkh"> Get Medical Supplies </Link>       
          </HStack>

        <HStack className="BottomNavbarBox">
        <div className="circular-imageh">
          <Image 
            src=".\icons\2.svg"
          />
          </div>
           <Link to="/digitalstore" className="custom-linkh"> Digitize Your Store </Link>       
          </HStack>
          
          <HStack className="BottomNavbarBox">
        <div className="circular-imageh">
          <Image 
            src=".\icons\3.svg"
          />
          </div>
           <Link to="/boostsales" className="custom-linkh"> Boost Sales Of Your Store </Link>       
          </HStack>

          <HStack className="BottomNavbarBox">
        <div className="circular-imageh">
          <Image 
            src=".\icons\4.svg"
          />
          </div>
           <Link to="/customizedproducts" className="custom-linkh"> Store Customized Products </Link>       
          </HStack>

          <HStack className="BottomNavbarBox">
        <div className="circular-imageh">
          <Image 
            src=".\icons\5.svg"
          />
          </div>
           <Link to="/fundsforbusiness" className="custom-linkh"> Get Funds  For Business </Link>       
          </HStack>
      </Flex>

      {}

    </Box>
  );
};

export default BottomNavbar;
